import { useLocalization } from "../../features/localization/index.js";
import { COLLAPSIBLE_SECTION_HEADING_LEVEL } from "./collapsible-section-heading-level.js";
import ValueEmitter_default from "./ValueEmitter.vue.js";
import { computed, createBlock, createCommentVNode, createElementBlock, createElementVNode, createTextVNode, createVNode, defineComponent, inject, mergeProps, normalizeClass, openBlock, renderSlot, resolveDynamicComponent, toDisplayString, toValue, unref, useId, withCtx } from "vue";
import { ScalarIcon } from "@scalar/components/icon";
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
//#region src/v2/components/layout/CollapsibleSection.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = ["aria-labelledby", "role"];
var _hoisted_2 = { class: "contents" };
var _hoisted_3 = {
	key: 0,
	class: "sr-only"
};
var _hoisted_4 = {
	key: 0,
	class: "bg-b-2 text-c-2 inline-flex h-5 w-5 items-center justify-center rounded-full border text-xs font-semibold"
};
var _hoisted_5 = { class: "sr-only" };
var _hoisted_6 = {
	key: 0,
	class: "ui-not-open:hidden flex items-center gap-2 pr-0.75"
};
var CollapsibleSection_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	name: "CollapsibleSection",
	props: {
		defaultOpen: {
			type: Boolean,
			default: true
		},
		heading: {
			type: Boolean,
			default: true
		},
		itemCount: { default: 0 },
		isStatic: { type: Boolean }
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const { translate } = useLocalization();
		/**
		* Defaults to `h2`, for a section that sits directly below the page title. A
		* parent that renders a title above its sections provides a deeper level.
		*/
		const headingLevel = inject(COLLAPSIBLE_SECTION_HEADING_LEVEL, 2);
		/**
		* The element that holds the title. A caller that opted out of the heading gets
		* a `span`, which reads as plain text and is also the only valid choice inside
		* the disclosure button, since a heading is not phrasing content.
		*/
		const titleTag = computed(() => __props.heading ? `h${toValue(headingLevel)}` : "span");
		/** Names the `group` a section without a heading becomes. */
		const titleId = useId();
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Disclosure), {
				as: "div",
				class: normalizeClass(["group/collapse text-c-2 focus-within:text-c-1 last:ui-open:border-b-0", {
					"last-of-type:first-of-type:border-b-0": __props.isStatic,
					"border-b": !__props.isStatic
				}]),
				defaultOpen: __props.defaultOpen,
				static: __props.isStatic
			}, {
				default: withCtx(({ open }) => [createVNode(ValueEmitter_default, {
					value: open,
					onChange: _cache[0] || (_cache[0] = (value) => emit("update:modelValue", value))
				}, null, 8, ["value"]), createElementVNode("section", {
					"aria-labelledby": __props.heading ? void 0 : unref(titleId),
					class: "contents",
					role: __props.heading ? void 0 : "group"
				}, [createElementVNode("div", { class: normalizeClass(["bg-b-2 flex items-center", __props.isStatic && "rounded-t-xl border-x border-t"]) }, [createVNode(unref(DisclosureButton), {
					class: normalizeClass(["hover:text-c-1 group box-content flex max-h-8 flex-1 items-center gap-2.5 overflow-hidden px-1 py-1.5 text-base font-medium outline-none md:px-1.5 xl:pr-0.5 xl:pl-2", __props.isStatic && "!pl-3"]),
					disabled: __props.isStatic
				}, {
					default: withCtx(() => [!__props.isStatic ? (openBlock(), createBlock(unref(ScalarIcon), {
						key: 0,
						class: "text-c-3 group-hover:text-c-1 rounded-px ui-open:rotate-90 ui-not-open:rotate-0 outline-offset-2 group-focus-visible:outline",
						icon: "ChevronRight",
						size: "md"
					})) : createCommentVNode("", true), (openBlock(), createBlock(resolveDynamicComponent(titleTag.value), {
						id: __props.heading ? void 0 : unref(titleId),
						class: "text-c-1 m-0 flex flex-1 items-center gap-1.5 leading-[20px]"
					}, {
						default: withCtx(() => [createElementVNode("span", _hoisted_2, [renderSlot(_ctx.$slots, "title", { open }), !open ? (openBlock(), createElementBlock("span", _hoisted_3, toDisplayString(unref(translate)("apiClient.collapsibleSection.collapsed")), 1)) : createCommentVNode("", true)]), !open && __props.itemCount ? (openBlock(), createElementBlock("span", _hoisted_4, [createTextVNode(toDisplayString(__props.itemCount) + " ", 1), createElementVNode("span", _hoisted_5, toDisplayString(__props.itemCount === 1 ? unref(translate)("apiClient.collapsibleSection.item") : unref(translate)("apiClient.collapsibleSection.items")), 1)])) : createCommentVNode("", true)]),
						_: 2
					}, 1032, ["id"]))]),
					_: 2
				}, 1032, ["class", "disabled"]), _ctx.$slots.actions ? (openBlock(), createElementBlock("div", _hoisted_6, [renderSlot(_ctx.$slots, "actions", { open })])) : createCommentVNode("", true)], 2), createVNode(unref(DisclosurePanel), mergeProps(_ctx.$attrs, { class: "diclosure-panel h-full max-h-fit rounded-b" }), {
					default: withCtx(() => [renderSlot(_ctx.$slots, "default", { open })]),
					_: 2
				}, 1040)], 8, _hoisted_1)]),
				_: 3
			}, 8, [
				"class",
				"defaultOpen",
				"static"
			]);
		};
	}
});
//#endregion
export { CollapsibleSection_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=CollapsibleSection.vue.script.js.map